import { useState } from 'react';
import HelpContent from './HelpContent';
import HelpSidebar from './HelpSidebar';

import data from './faq-data.json';

import './styles.scss';

export type IFaq = Array<{
  name: string;
  sub_items: Array<{ name: string; text: string }>;
}>;

const HelpBody = () => {
  const [content, setContent] = useState(data[0].sub_items[0].text);

  return (
    <div className='help'>
      <HelpSidebar data={data} setContent={setContent} />
      <HelpContent content={content} />
    </div>
  );
};

export default HelpBody;
